function toggleAccordion(accordion, expand) {
  const content = accordion.querySelector('.accordion-content');

  if (expand) {
    accordion.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    accordion.classList.remove('active');
    content.style.maxHeight = '0';
  }
}

document.querySelectorAll('.accordion').forEach(accordion => {
  const header = accordion.querySelector('.accordion-header');
  const content = accordion.querySelector('.accordion-content');

  // Open on load if active
  if (accordion.classList.contains('active')) {
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  header.addEventListener('click', () => {
    const isOpen = accordion.classList.contains('active');
    toggleAccordion(accordion, !isOpen);
  });

  // Ensure height is reset on transition end (nice cleanup)
  content.addEventListener('transitionend', () => {
    if (!accordion.classList.contains('active')) {
      content.style.maxHeight = '0';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});